<div
  class="bg-black/50 sm:bg-transparent fixed left-0 right-0 top-0 bottom-0 w-full h-full z-40"
  tabindex="0"
  [class.block]="notificationsService.isOpen"
  [class.hidden]="!notificationsService.isOpen"
  (click)="notificationsService.closeNotifications()"
></div>

<div
  class="fixed z-50 left-0 right-0 top-[calc(87.25px+--spacing(4))] bottom-0 w-full rounded-tl-[20px] rounded-tr-[20px] sm:rounded-tl-none sm:rounded-tr-none sm:bottom-4 sm:left-auto sm:right-4 sm:w-[400px] bg-white overflow-hidden"
  [class.block]="notificationsService.isOpen"
  [class.hidden]="!notificationsService.isOpen"
>
  <div class="relative flex items-center justify-center font-bold p-5 border-b border-grey-300">
    <h3 class="text-black text-lg">{{ 'notifications.title' | transloco }}</h3>
    <button class="absolute right-3 top-1/2 -translate-y-1/2 p-3 cursor-pointer" (click)="notificationsService.closeNotifications()">
      <i class="pi pi-times text-grey-600"></i>
    </button>
  </div>
  <div class="h-full">
    @if (notifications$ | async; as notifications) {
      <div class="flex justify-between py-3 px-5">
        <span class="text-grey-400">{{ 'notifications.allNotifications' | transloco }}</span>
        <button class="text-blue-interact hover:underline cursor-pointer" (click)="markAllAsRead(notifications)">{{ 'notifications.markAllAsRead' | transloco }}</button>
      </div>

      <div class="h-[calc(100%-106px)] overflow-y-auto">
        @for (notification of notifications; track notification.id) {
          <div class="flex gap-3 p-5 border-b border-grey-300 last:border-b-0">
            <div class="relative mt-1" [class.hidden]="notification.isRead" [class.block]="!notification.isRead">
              <div class="absolute top-0 left-0 w-4 h-4 bg-jcb rounded-full animate-ping opacity-75"></div>
              <div class="min-w-4 h-4 bg-jcb rounded-full"></div>
            </div>
            <div class="relative grow-1">
              <a
                [routerLink]="notification.machineId ? ['/machine', notification.machineId] : null"
                (click)="handleNotificationClick($event, notification)"
                [class.cursor-not-pointer]="!notification.machineId"
              >
                <h4 class="font-bold">{{ notification.title }}</h4>
              </a>
              <div class="flex">
                <app-truncate-text [limit]="descriptionLimit" text="{{ notification.body }}"/>
                <span class="self-end right-0 bottom-0 text-grey-400 whitespace-nowrap ml-auto" [class.absolute]="notification.body.length > descriptionLimit">{{ notification.createdAt | datetimeShortener }}</span>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
